module.exports = __webpack_public_path__ + "static/img/pfyh.d2e92827.png";